
import React, { useState, useEffect,useContext } from 'react';

import { Link, useNavigate,useParams  } from 'react-router-dom';
import DynamicIcon from '../components/dynamicicon';
import JisButton from '../components/controls/jisButton';
import JisDropdown from '../components/controls/jisDropdown';
import FlowItem from '../components/controls/flowitem';
import { ShareContext } from '../context/ShareContext';

import * as Constants from '../constants';
import BackLoader from '../components/backloader';
import Payment from '../components/core/payment';
import OTPInput from '../components/controls/otpinput';
import JisDialog from '../components/dialog';
import CaseSearch from '../components/core/case_search';
import JisEmptyList from '../components/controls/emptylist';
import JisCheckbox from '../components/controls/jisCheckbox';
import JisParty from '../components/controls/jisparty';
import JisDialogForm from '../components/formdialog';
import JisTabButton from '../components/controls/jisTabButton';
function CaseAssociations() {
  const {  activePage, token, profile,frequentData,setIsExpired, setAlert} = useContext(ShareContext);
   const [cases, setCases] = useState([]);
    const [tab, setTab] = useState("pending");
const [associates, setAssociates] =useState([])
 const [loading, setLoading] =useState(false);
    const [pageIndex, setPageIndex]=useState(0);
    const [pageSize,setPageSize] = useState(Constants.PAGESIZE);
    const [isSearch, setIsSearch] =useState(false);
    const [search, setSearch]=useState(null);
    const [active, setActive] =useState(null);
       const [index, setIndex] = useState(-1);
    const [isPreview, setIsPreview] = useState(false);
     const [count,setCount] = useState(0);

    const [open, setOpen] =useState(false);
         const [approve, setApprove] =useState(false);
        const [err, setErr] = useState('');
        const [isApproval, setIsApproval] = useState(null);
        const [option, setOption] = useState({});

    useEffect(() => {
              if(pageIndex>=0){
                onLoad();
              }else{
                setPageIndex(0);
              }
              
             
            }, [pageIndex,pageSize,tab]);
const onLoad= async()=>{
              //for account registration
          try {
  
              setLoading(true);
              const resp = await fetch(`${Constants.apiUrl}/filing/get-case-associations/${tab}/${pageIndex}/${pageSize}`, { //
                  method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': `Bearer ${token}`,}, });  
              const data = await resp.json();
              setLoading(false);
              if(data.code==0){
                  //ready
                  // fee, feelines, cinfo , parties 
                setAssociates(data.items)
                 if(pageIndex==0){
                  setCount(data.totalCount)
                 }
                
              } else if(data.code==-10){
                        setIsExpired(true);
                    }
              
              } catch (error) {
              setLoading(false);
              console.error(error);   
              }
          }
          
    const onApprove=(item,index)=>{
        console.log(tab);
        setActive(item);
        setApprove(true);
    } 
 const  onSaveApprove =async(e)=>{
     e.preventDefault();

             if(isApproval==null){
               setErr('Please select the Approval Option');
               return;
             }
                var op={id:active?.id, status:isApproval,reason:option.reason}
             setLoading(true)
                try {
                
                    const resp = await fetch(`${Constants.apiUrl}/profile/approve-firm`, {
                    method: 'POST',
                    body:JSON.stringify(op) ,
                    headers: {
                    'Content-Type': 'application/json, text/plain',
                    Authorization: `Bearer ${token}`,
                    },
                });
                
                const data = await resp.json();
                setLoading(false);
                console.log(data);
                if(data.code==0){
                //update the field
                    setApprove(false)
                    setAlert({open:true, title:'Case Association', subtitle:`Case Association ${isApproval?'Approved':'Reject'} successfully`});
                    setPageIndex(-1); // this will auto load again
                 
                    
                } else if(data.code==-10){
                    setIsExpired(true);
                }else{
                //there is an error
                setErr(data.status);
                }
                
                } catch (error) {
                setLoading(false);
                console.error(error);
                setErr(Constants.serverErr);
                // onMove();
                }
   } 
const onClear =(item,index)=>{

}
const onEdit =(item,index)=>{

}
const onContinue=()=>{
  
}

const onValidateToken=async(item,index)=>{
          setErr('');
             
          var re={id:item.id,token:item.token }
                  setLoading(true)
                  try {
                    
                    const resp = await fetch(`${Constants.apiUrl}/filing/case-association-validation/${item?.case.caseId}`, {
                      method: 'POST',
                      body:JSON.stringify(re) ,
                      headers: {
                        'Content-Type': 'application/json, text/plain',
                        Authorization: `Bearer ${token}`,
                      },
                    });
                    
                    const data = await resp.json();
                    setLoading(false);
                   if(data.code==0){
                    //update the field
                  //   setValidate({isApproved:data.isApproved,isAdminRequired:data.isAdminRequired});
                   // setIsOtp(false)
                   onLoad();
                    } else if(data.code==-10){
                      setIsExpired(true);
                  }else{
                    //there is an error
                    setErr(data.status);
                   }
                    
                  } catch (error) {
                    setLoading(false);
                    console.error(error);
                    setErr(Constants.serverErr);
                   // onMove();
                  }
    }

  return (
    <div>
      <div className='tab_body'>
         <div className='tab_section'>
            <JisTabButton isActive={tab=='pending'}  
       title="Pending" 
       isRoleBased={false} onClick={()=> setTab('pending')}/>
       <JisTabButton isActive={tab=='approved'}  title="Approved Association" 
       isRoleBased={false} onClick={()=> setTab('approved')}/>
       <JisTabButton isActive={tab=='rejected'}  title="Rejected Association" 
       isRoleBased={false} onClick={()=> setTab('rejected')}/>
        </div>
        <div  className='tab_view'>
            {associates?.length==0 && <JisEmptyList/>}
            {associates?.length>0 && <div className='table'>
                <div class="section-cases">
                <span>Association</span><span className='total'>{count}</span>
                </div>
                <table className="case-table">
                    <thead>
                       <tr>
                        <th>SN</th>
      <th>Suit Number</th>
      <th>Case Title</th>
      <th>Parties</th>
      <th>Legal Counsel</th>
      <th>Request Date</th>

      <th>Admin Required </th>
      <th>Token</th>
    {/*   <th>Details</th> */}
      <th>Action</th>
    </tr>
                    </thead>
                     <tbody>
     {associates?.map((opt, index) => (
       <tr key={index} >
        <td>{index+1}</td>
     <td>{opt.case?.caseNumber?? opt.case?.referenceNumber}</td>
           <td>{opt.case?.caseTitle}</td>
            <td>
              {opt.parties[0]?.firstName} {opt.parties[0]?.lastName??''}
            </td>
           <td> {opt.legalCounsel?.firstName} {opt.legalCounsel?.lastName??''}</td>
            <td> {Constants.momentDate(opt.createDate).format('DD MMM, YYYY')}</td>
           <td>{opt.isAdminRequired==true?'Yes':'No'}</td>
            <td>{opt.token}</td>
     {/* <td><JisButton onClick={()=>onContinue(opt.caseId)}>View</JisButton></td> */}
     
     {tab=="pending" && <td>
        
        <JisButton  variant='plain' onClick={()=>onValidateToken(opt,index)}>Approve</JisButton>
     </td>} 
    {/*  {tab=="approved" && <td><JisButton onClick={()=>onClear(opt,index)}>Clear</JisButton></td>} 
    {tab=="rejected" && <td><JisButton onClick={()=>onClear(opt,index)}>Clear</JisButton></td>}  */}
    </tr>
    ))} 
    


  </tbody>
                </table>    
                </div>}
        </div>
      </div>

      
    </div>
  );
}

export default CaseAssociations;